import React, { useMemo, useState } from "react";
import { Broadcast } from "../../pages";
import { BroadcastController } from "../../controllers";
import { useNavigate } from "react-router-dom";
import { adminStore } from "../../stores";
import constant from "../../utils/constant";

const BroadcastContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const [deleteBroadcastModal, setDeleteBroadcastModal] = useState(false);

  const broadcastTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = BroadcastController.useGetBroadcast(
    broadcastTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const navigate = useNavigate();

  const goToCreateBroadcast = () => {
    navigate(constant.Routes.CreateBroadcast);
  };
  const goToUpdateBroadcast = () => {
    navigate(constant.Routes.UpdateBroadcast);
  };
  const goToCloneBroadcast = () => {
    navigate(constant.Routes.CloneBroadcast);
  };

  const goToViewMore = () => {
    navigate(constant.Routes.ViewMoreBroadcast);
  };

  const goToDelete = () => {
    setDeleteBroadcastModal(true);
  };

  const closeModal = () => {
    adminStore.setSingleBroadcast({});
    setDeleteBroadcastModal(false);
  };
  return (
    <Broadcast
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      closeModal={closeModal}
      goToCreateBroadcast={goToCreateBroadcast}
      goToViewMore={goToViewMore}
      goToDelete={goToDelete}
      deleteBroadcastModal={deleteBroadcastModal}
      goToUpdateBroadcast={goToUpdateBroadcast}
      goToCloneBroadcast={goToCloneBroadcast}
    />
  );
};

export default BroadcastContainer;
